<template>
  <div class="custom-datepicker-wrapper" :class="datePickerClass">
    <template v-if="label">
      <label
        :for="label"
        class="text-text-primary text-sm font-medium dark:text-text-primary-dark"
        :class="[labelClass, allowLabelWrap ? '' : 'label-wrapper']"
      >
        {{ label }}
        <span v-if="required" class="ml-1">
          (Obligatorio)<span class="text-text-error">*</span>
        </span>
      </label>
    </template>
    <DatePicker
      v-model="model"
      :selectionMode="selectionMode"
      :manualInput="manualInput"
      :inputClass="inputClass"
      :placeholder="placeholder"
      :icon="icon"
      :showIcon="showIcon"
      :dateFormat="dateFormat || 'dd/mm/yy'"
      :showButtonBar="showButtonBar"
      :showTime="showTime"
      :hourFormat="hourFormat"
      :timeOnly="timeOnly"
      :view="view"
      :numberOfMonths="numberOfMonths"
      :minDate="minDate"
      :maxDate="maxDate"
      :inline="inline"
      :variant="variant"
      :disabled="disabled"
      :readonly="readonly"
      :invalid="invalid"
      iconDisplay="input"
      appendTo="body"
    />
  </div>
</template>

<script setup lang="ts">
import { DatePicker } from "primevue";

defineProps<{
  selectionMode?: "single" | "multiple" | "range";
  manualInput?: boolean;
  inputClass?: string;
  placeholder?: string;
  icon?: string;
  showIcon?: boolean;
  dateFormat?: string;
  showButtonBar?: boolean;
  showTime?: boolean;
  hourFormat?: "12" | "24";
  timeOnly?: boolean;
  view?: "date" | "month" | "year";
  numberOfMonths?: number;
  minDate?: Date;
  maxDate?: Date;
  inline?: boolean;
  variant?: "outlined" | "filled";
  disabled?: boolean;
  readonly?: boolean;
  invalid?: boolean;
  datePickerClass?: string;
  label?: string;
  labelClass?: string;
  allowLabelWrap?: boolean;
  required?: boolean;
}>();

const model = defineModel<any>();
</script>

<style scoped>
.custom-datepicker-wrapper {
  display: inline-block;
}

/* Asegurar que el datepicker esté por encima de modales */
.p-datepicker {
  z-index: 5 !important;
}

.p-datepicker-panel {
  z-index: 9999 !important;
}

/* Para el overlay del datepicker */
.p-component-overlay {
  z-index: 9999 !important;
}
</style>
